/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://5lat2oorrfe4rlongnapa4wtwu.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-lgcg2uec6jg4ndmbpxaa5awcy4",
    "aws_cognito_identity_pool_id": "us-east-1:7630722d-0cc2-4a54-93e4-fe65e1647ec4",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Oo3U0bJOP",
    "aws_user_pools_web_client_id": "jm3i4hid7glhdfrb2v81q38d3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "platformde0a42c18c744a9cae17f9d001d263e914898-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
